import React from "react";
import Layout from "@/components/Layout";
import SectionHeader from "@/components/SectionHeader";
import { useI18n } from "@/i18n";
import { brandAssets } from "@/data/brand";
import { Award, Gauge, ShieldCheck } from "lucide-react";

export default function About() {
  const { t } = useI18n();
  const body = t("about.body");
  const values = t("about.values");
  const valueIcons = [Award, ShieldCheck, Gauge];

  return (
    <Layout seoTitle={t("about.title")} seoDescription={t("about.subtitle")}>
      <section className="section-y">
        <div className="container-mt grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <SectionHeader as="h1" num="01" kicker="MAD TURBO" title={t("about.title")} subtitle={t("about.subtitle")} />
            <div className="space-y-5 text-zinc-300 leading-relaxed max-w-2xl">
              {body.map((p, i) => <p key={i} className="text-base md:text-lg">{p}</p>)}
            </div>
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
              {values.map((v, i) => {
                const Icon = valueIcons[i % valueIcons.length];
                return (
                  <div key={i} className="card-mt card-mt-pad">
                    <div className="icon-tile mb-4"><Icon size={18} /></div>
                    <h3 className="text-white font-display font-bold uppercase mb-1 text-xl">{v.t}</h3>
                    <p className="text-zinc-400 text-sm leading-relaxed">{v.d}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="lg:col-span-5 space-y-4">
            <img src={brandAssets.garage} alt="MAD TURBO workshop" className="rounded-2xl border border-zinc-800 w-full object-cover aspect-[4/3]" loading="lazy" />
            <div className="grid grid-cols-2 gap-4">
              <img src={brandAssets.eventBooth} alt="MAD TURBO event booth" className="rounded-2xl border border-zinc-800 w-full h-40 object-cover" loading="lazy" />
              <img src={brandAssets.driftCar} alt="MAD TURBO drift car" className="rounded-2xl border border-zinc-800 w-full h-40 object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
